/**
 * Lấy staff theo đúng thứ tự id truyền vào (thứ tự user chọn), bỏ qua id không
 * có trong list. Nhờ vậy staff không làm việc trong ngày đang xem sẽ không sinh
 * ra cột rỗng, và staff object luôn là bản mới nhất chứ không phải snapshot cũ.
 */
export const pickStaffsByIds = <T extends { id: string }>(
  list: T[],
  ids: string[]
): T[] => {
  if (!ids?.length || !list?.length) return [];
  const byId = new Map(list.map((o) => [o.id, o]));
  return ids.reduce<T[]>((acc, id) => {
    const item = byId.get(id);
    if (item) acc.push(item);
    return acc;
  }, []);
};

/**
 * Đưa staff được pin lên đầu danh sách theo thứ tự user chọn, phần còn lại giữ
 * nguyên thứ tự gốc.
 *
 * Trả về chính list gốc khi không pin được ai — giữ reference identity để
 * useMemo phía dưới không bị invalidate vô cớ.
 */
export const pinStaffsToFront = <T extends { id: string }>(
  list: T[],
  ids: string[]
): T[] => {
  const pinned = pickStaffsByIds(list, ids);
  if (!pinned.length) return list;
  const pinnedSet = new Set(pinned.map((o) => o.id));
  return [...pinned, ...list.filter((o) => !pinnedSet.has(o.id))];
};

export default pinStaffsToFront;
